module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Using this Guidebook")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In compiling the guide we have taken the liberty of using a number of abbreviations in the text. With German units we have simply trimmed Infantry Regiment and Reserve Infantry Regiment to IR and RIR. Thus, Infantry Regiment No. 157 becomes IR 157 and Reserve Infantry Regiment No. 165 becomes RIR 165. Bavarian Reserve Infantry Regiments appear with the BRIR. British battalions and units have also been abbreviated, for example, the 1st Battalion West Yorkshire Regiment becoming 1/West Yorks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whilst we have provided simple route maps for walkers and cyclists, we have not drawn maps for the car tours. These are best supported by French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Institut Géographique National")]), _vm._v(" (IGN) 1:100,000 maps which can be purchased at most good tourist offices and online from "), _c('a', {
    attrs: {
      "href": "http://www.mapsworldwide.com",
      "target": "_blank"
    }
  }, [_vm._v("www.mapsworldwide.com")]), _vm._v(". However, we do recommend satellite navigation in supporting general route finding. For the walker and cyclist, the larger scale French IGN 1:25,000 Series maps can be bought in France or online and can be downloaded onto your iPad. The relevant map should be used when out walking or cycling to supplement the basic maps provided in the guide.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f024-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c446e1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/36_fm044.vue
// module id = 165
// module chunks = 0